import { css } from 'aphrodite';
import * as React from 'react';
import { useParams } from 'react-router-dom';
import { IImpersonationContext } from '../../../extViewmodels';
import {
	AIAgentTemplateFilterProperty,
	AIAgentTemplateScope,
	AIConversationType,
} from '../../../extViewmodels/sdk/models/AI';
import { useAIAgentTemplateFilterInfiniteQuery } from '../../../queries/AIAgentTemplate';
import { LoadingSpinner } from '../../../web/components/LoadingSpinner';
import { CustomerAssistantEditor } from './CustomerAssistantEditor';
import { styles } from './styles';

export function AccountCustomerAssistant() {
	const params = useParams<{ accountId: string }>();
	const impersonationContext: IImpersonationContext = React.useMemo(
		() => ({ account: { id: params.accountId } }),
		[params.accountId]
	);

	const { data, isPending, isError } = useAIAgentTemplateFilterInfiniteQuery({
		filter: {
			criteria: [
				{ property: AIAgentTemplateFilterProperty.Scope, value: AIAgentTemplateScope.Account },
				{ property: AIAgentTemplateFilterProperty.ConversationType, value: AIConversationType.Custom },
			],
		},
		enabled: !!params.accountId,
		impersonationContext,
	});

	// Show loading state
	if (isPending) {
		return (
			<div className={css(styles.container)}>
				<div className={css(styles.header)}>
					<h1 className={css(styles.title)}>Loading Customer Assistant...</h1>
				</div>
				<LoadingSpinner />
			</div>
		);
	}

	// Show error state
	if (isError) {
		return (
			<div className={css(styles.container)}>
				<div className={css(styles.header)}>
					<h1 className={css(styles.title)}>Error</h1>
				</div>
				<p>Error loading Customer Assistant configuration. Please try again.</p>
			</div>
		);
	}

	// Determine mode: create if no templates, edit if templates exist
	const existingTemplate = data?.pages[0]?.values?.[0];
	const isCreateMode = !existingTemplate;

	return (
		<CustomerAssistantEditor
			accountId={params.accountId}
			impersonationContext={impersonationContext}
			existingTemplate={existingTemplate}
			isCreateMode={isCreateMode}
		/>
	);
}
